/** @format */

import React from 'react';
import { InputBase } from '@material-ui/core';
import { ContentsWrap, VerticalSp, VSLine } from '../../components/Common';
import {
  AutoForm,
  PageTitle,
  PageDescipt,
  InputErrMsg,
  AuthButton,
  CheckBox,
  OrSplite,
  SNSRow,
  ForgetSign,
  SubBtn,
  CheckMark,
  InputPlaceHolder,
} from '../../components/auth/login';
import {
  SnSNaver,
  SnSKakao,
  SnSFaceBook,
  SnSApple,
  SnSGoogle,
  InputGroup,
  InputPad,
  inputStyle,
} from '../../components/auth/login';
import { loginUser } from '../../_actions/userAction';
import { withTranslation } from 'react-i18next';
import apiClient from '../../_utils/axios';
import Store from 'store';
import ReactGA from 'react-ga';
import { emailExp } from '../../constant/auth.constant';
import { marketingApi } from '../../marketing-api';

class LoginPage extends React.Component {
  state = {
    account: '',
    accountmsg: '',
    password: '',
    passwordmsg: '',
    autologin: false,
    loginSuccess: null,
    returnPath: '',
  };

  constructor(props) {
    super();
  }

  componentDidMount = () => {
    window.AppleID.auth.init({
      clientId: 'com.textiledesignbank.services',
      scope: 'email',
      redirectURI: `https://${window.location.hostname}`,
      state: 'A213',
      usePopup: true,
    });
    window.gapi.load('auth2', function () {
      // Retrieve the singleton for the GoogleAuth library and set up the client.
      window.auth2 = window.gapi.auth2.init({
        client_id: '886225461254-gkqf3ldb01soq0p5oq5ck8n9m2havpd1.apps.googleusercontent.com',
        cookiepolicy: 'single_host_origin',
        // Request scopes in addition to 'profile' and 'email'
        scope: 'email profile openid https://www.googleapis.com/auth/user.birthday.read',
      });
    });

    // 네이버 로그인 콜백 체크
    if (window.location.href.includes('access_token')) {
      this.onNaverLoginCallback(window.location.href.split('=')[1].split('&')[0]);
    }

    // if (window.location.pathname !== '/auth') {
    //   Store.set('returnPath', window.location.pathname);
    //   this.setState({
    //     returnPath: window.location.pathname,
    //   });
    // } else {
    //   if (!window.location.href.includes('access_token')) Store.remove('returnPath', '');
    // }
  };

  onAutoLogin = () => {
    const { autologin } = this.state;
    this.setState({ autologin: !autologin });
    Store.set('auto_login', !autologin);
  };

  onGoogleLoginCallback = async (e) => {
    window.auth2.attachClickHandler(
      e,
      {},
      function (googleUser) {
        var access_token = googleUser.getAuthResponse().access_token;
        // console.log(access_token);
      },
      function (error) {
        // alert(JSON.stringify(error, undefined, 2));
      },
    );
  };

  onNaverLoginCallback = async (e) => {
    const res = await apiClient.post('/auth/login/sns', {
      token: e,
      type: 'NAVER',
      command: Store.get('command'),
    });

    if (res) {
      Store.set('authdata', 1);
      Store.set('accessToken', res.data.accessToken);
      Store.set('userData', res.data);
      marketingApi.useLoginEffect('naver');
      this.loginSuccess();
    }
  };

  onNaver = () => {
    const naver_id_login = new window.naver_id_login(
      'DMKdNbeL_FgixNftcnvM',
      `${window.location.protocol}//${window.location.host}/auth`,
    );
    const state = naver_id_login.getUniqState();
    naver_id_login.setButton('green', 2, 40);
    naver_id_login.setState(state);
    naver_id_login.init_naver_id_login();
  };

  onKaKao = () => {
    const { Kakao } = window;
    Kakao.Auth.login({
      success: async (authObj) => {
        const res = await apiClient.post('/auth/login/sns', {
          token: authObj.access_token,
          refresh_token: authObj.refresh_token,
          type: 'KAKAO',
          command: Store.get('command'),
        });
        if (res) {
          Store.set('authdata', 1);
          Store.set('accessToken', res.data.accessToken);
          Store.set('userData', res.data);
          marketingApi.useLoginEffect('kakao');
          this.loginSuccess();
        }
      },
      fail: function (err) {
        console.log('에러', err);
      },
    });
  };

  onFaceBook = () => {
    const self = this;
    window.FB.login(
      function (response) {
        // 이 함수는 async로 설정하지 않습니다.
        console.log(response);
        if (response.status === 'connected') {
          // 비동기 호출을 위해 Promise 사용
          apiClient
            .post('/auth/login/sns', {
              token: response.authResponse.accessToken,
              userID: response.authResponse.userID,
              fields: 'name,email',
              type: 'FACEBOOK',
              command: Store.get('command'),
            })
            .then((res) => {
              if (res) {
                Store.set('authdata', 1);
                Store.set('accessToken', res.data.accessToken);
                Store.set('userData', res.data);
                marketingApi.useLoginEffect('facebook');
                self.loginSuccess();
              }
            })
            .catch((err) => {
              console.error(err);
              // 에러 처리 추가 가능
            });
        } else if (response.status === 'not_authorized') {
          if (Store.get('lang') === 'kr') {
            alert('페이스북에 로그인에 실패하였습니다.');
          } else {
            alert('Failed to log in to Facebook.');
          }
        } else {
          if (Store.get('lang') === 'kr') {
            alert('페이스북에 로그인에 실패하였습니다.');
          } else {
            alert('Failed to log in to Facebook.');
          }
        }
      },
      { scope: 'public_profile,email' },
    );
  };

  onApple = async () => {
    try {
      const data = await window.AppleID.auth.signIn();
      const res = await apiClient.post('/auth/login/sns', {
        code: data.authorization.code,
        token: data.authorization.id_token,
        type: 'APPLE',
        command: Store.get('command'),
      });

      if (res) {
        Store.set('authdata', 1);
        Store.set('accessToken', res.data.accessToken);
        Store.set('userData', res.data);
        marketingApi.useLoginEffect('apple');
        this.loginSuccess();
      }
    } catch (error) {
      if (error.error !== 'popup_closed_by_user') alert('애플 로그인에 실패하였습니다\n[' + error.error + ']');
    }
  };

  onGoogle = () => {
    window.auth2.signIn().then(
      async (googleUser) => {
        const res = await apiClient.post('/auth/login/sns', {
          token: googleUser.getAuthResponse().id_token,
          scope: googleUser.getAuthResponse().scope,
          type: 'GOOGLE',
          command: Store.get('command'),
        });

        if (res) {
          Store.set('authdata', 1);
          Store.set('accessToken', res.data.accessToken);
          Store.set('userData', res.data);
          marketingApi.useLoginEffect('google');
          this.loginSuccess();
        }
      },
      (err) => {
        console.log(err);
      },
    );
  };

  onForget = () => {
    this.props.history.push('/auth/forgetpsw');
  };

  onSignup = () => {
    this.props.history.push('/auth/signup');
  };

  onLogin = () => {
    if (this.state.account.length < 1) {
      let err = '';

      if (Store.get('lang') === 'kr') {
        err = '아이디(이메일주소)를 입력해주세요.';
      } else {
        err = 'Please enter a email.';
      }

      this.setState({
        accountmsg: err,
      });
      return false;
    } else {
      this.setState({
        accountmsg: '',
      });
    }

    if (this.state.password.length < 1) {
      let err = '';

      if (Store.get('lang') === 'kr') {
        err = '비밀번호를 입력해주세요.';
      } else {
        err = 'Please enter a password.';
      }
      this.setState({
        passwordmsg: err,
      });
      return false;
    } else {
      this.setState({
        passwordmsg: '',
      });
    }

    if (this.state.account.match(emailExp) === null) {
      let err = '이메일 형식이 올바르지 않습니다.';

      if (Store.get('lang') !== 'kr') {
        err = 'Invalid email format.';
      }

      this.setState({
        accountmsg: err,
      });
      return false;
    } else {
      this.setState({
        accountmsg: '',
      });
    }

    let body = {
      email: this.state.account,
      password: this.state.password,
    };

    const loginResponse = loginUser(body);
    loginResponse.then((res) => {
      // 로그인 실패시 액션 없음
      // console.log('res',res)
      if (!!res && !res.payload) {
        if (Store.get('lang') === 'kr') {
          alert('아이디 또는 비밀번호를 확인해주세요.');
        } else {
          alert('Please check your email or password.');
        }
        return;
      }

      if (!!res && !!res.payload && res.payload.message === '아이디 또는 비밀번호를 확인해주세요.') {
        let err = '아이디 또는 비밀번호를 확인해주세요.';

        if (Store.get('lang') !== 'kr') {
          err = 'Please check your email or password.';
        }
        this.setState({
          passwordmsg: err,
        });
      }

      if (!!res && !!res.payload && res.payload.accessToken) {
        if (res.payload.is_email_verified === true) {
          marketingApi.useLoginEffect('email');
          this.loginSuccess();
        } else if (res.payload.is_email_verified === false) {
          this.props.history.push('/auth/email/register');
        }
      }
    });
  };

  loginSuccess() {
    if (process.env.NODE_ENV === 'production') {
      const userData = Store.get('userData');
      if (userData) {
        ReactGA.set({ userId: userData.id });
      }
    }

    if (this.state.returnPath) {
      window.location.href = this.state.returnPath;
      return;
    } else {
      const returnPath = Store.get('returnPath');
      if (returnPath) {
        Store.remove('returnPath', '');
        window.location.href = returnPath;
        return;
      }
      window.location.href = '/';
    }
  }

  render() {
    const { t, isPopup = false } = this.props;
    const { account, password, accountmsg, passwordmsg, autologin } = this.state;
    return (
      <ContentsWrap>
        <AutoForm height={isPopup ? '100%' : '760px'}>
          <PageTitle>{t('sign_in')}</PageTitle>
          <VerticalSp sp={'1vw'} style={{ minHeight: 10 }} />
          <PageDescipt>{t('sign_in_to_your_account')}</PageDescipt>
          <VerticalSp sp={'2.3vw'} style={{ minHeight: 20 }} />
          <div style={{ width: '100%' }}>
            <InputPad>
              <InputBase
                autoFocus={false}
                value={account}
                onChange={(event) => {
                  this.setState({ account: event.target.value });
                }}
                inputProps={{ style: inputStyle }}
                style={{ width: '100%', borderBottom: '1px solid #999999' }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    this.onLogin();
                  }
                }}
                placeholder={account === '' ? t('email_address') : ''}
              />
            </InputPad>
            <InputErrMsg>{accountmsg}</InputErrMsg>
            <VerticalSp sp={6} />
            <InputPad>
              <InputBase
                type="password"
                autoFocus={false}
                value={password}
                onChange={(event) => {
                  this.setState({ password: event.target.value });
                }}
                inputProps={{ style: inputStyle }}
                style={{ width: '100%', borderBottom: '1px solid #999999' }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    this.onLogin();
                  }
                }}
                placeholder={password === '' ? t('password') : ''}
              />
            </InputPad>
            <InputErrMsg>{passwordmsg}</InputErrMsg>
            <VerticalSp sp={6} />
            <AuthButton onClick={this.onLogin}>{t('do_sign_in')}</AuthButton>
            <VerticalSp sp={10} />
            <CheckBox onClick={this.onAutoLogin}>
              <CheckMark checked={autologin} />
              <p style={{ marginLeft: '6px' }}>{t('automatic_sign_in')}</p>
            </CheckBox>
            <VerticalSp sp={'2.6vw'} style={{ minHeight: 30 }} />
            <OrSplite />
            <VerticalSp style={{ minHeight: 30 }} />
            <SNSRow>
              <SnSNaver onClick={this.onNaver} />
              <SnSKakao onClick={this.onKaKao} />
              <SnSFaceBook onClick={this.onFaceBook} />
              <SnSApple onClick={this.onApple} />
              <SnSGoogle onClick={this.onGoogle} />
            </SNSRow>
            <VerticalSp style={{ minHeight: 30 }} />
            <ForgetSign>
              <SubBtn onClick={this.onForget}>{t('forgot')}</SubBtn>
              <VSLine />
              <SubBtn onClick={this.onSignup}>{t('sign_up')}</SubBtn>
            </ForgetSign>
          </div>
        </AutoForm>
      </ContentsWrap>
    );
  }
}

export default withTranslation()(LoginPage);
